import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "../Navigations/MainNavigation";
import RulesNav from "./Nav";
import Footer from "../Footer";

import styled from "styled-components";
const ContainerMain = styled.div`
  width: 100%;
`;
const Container = styled.div`
  width: 80%;
  height: 1200px;
  padding-top: 100px;
  margin-left: 10%;
`;
const Nav = styled.div`
  width: 20%;
  height: 100%;
  float: left;
`;

const MainContent = styled.div`
  width: 78%;
  float: right;
`;
const Title = styled.h1`
  font-weight: 600;
  font-size: 2em;
  margin: 0;
  padding: 0;
`;
const SubTitle = styled.h2`
  font-weight: 600;
  font-size: 1.2em;
  margin: 30px 0 10px 0;
  padding: 0;
`;
const TextBlock = styled.p`
  color: #636161;
`;

function DataSecuirity() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <ContainerMain>
      <Navigation />
      <Container>
        <Nav>
          <RulesNav />
        </Nav>
        <MainContent>
          <Title>Privacy And Data Securiy Policy</Title>
          <SubTitle>Transaction</SubTitle>
          <TextBlock>
            Maplun.com is committed to protect your privacy. The security of
            your personal info is incredibly vital to us. We generally emphasize
            on COD (Cash on Delivery) where no critical financial or security
            issue arises. Mode of COD is taken as quite easy, transparent and
            direct with buyers and sellers. In case of electronic payment, once
            you enter sensitive info (such as a MasterCard number) on the order
            forms, we use the secure socket layer technology (SSL). Once we
            receive the info it's right away re-encrypted before storage.
          </TextBlock>
          <TextBlock>
            Maplun.com follows usually accepted business standards and
            government rules and regulations to guard your non-public info
            throughout the business process. In general, no technique of
            transaction over the internet, or technique of electronic storage,
            is 100% secure. So, we heavily encourage COD method for the
            transaction of deals.
          </TextBlock>
          <SubTitle>Use of Your Data</SubTitle>
          <TextBlock>
            Maplun.com collects the data while on registration, by which we
            ensure your usages of our service through the information processing
            system. We will use your info to provide Maplun.com’s services that
            can help us improve our service delivery to you. We also preserve
            data and info in reference to your participation in any promotional
            programs. We additionally collect info regarding the transactions
            you undertake, as well as details of payment.
          </TextBlock>
          <TextBlock>
            We will additionally use your contact details to communicate with
            you if needed. If you would like to discontinue receiving any
            promotional emails, or notification of any type via your email,
            mobile you're suggested to unsubscribe us. Maplun.com would like to
            listen to your views to improve our service, so that, from time to
            time, might contact you to solicit your opinions. Please note that
            there could also be instances wherever it's going to be necessary
            for us to speak with you. Maplun.com reserves the right to change
            this privacy statement at any time, thus please review it often.
          </TextBlock>
          <SubTitle>Cookie Policy</SubTitle>
          <TextBlock>
            Maplun.com uses cookies for variety of functions to make sure the
            security and genuineness of registered users. It can use as the
            mechanisms for online application and to change traffic observance
            by tracking of - location change, category change and other relevant
            data for registered users safely
          </TextBlock>
          <TextBlock>
            Maplun.com uses each session ID cookies and/or persistent cookies.
            We use session cookies to create it easier for you to navigate our
            website. A session ID cookie expires once you shut your browser. A
            persistent cookie remains on your drive for easing extended amount
            of your time, unless you take away the cookie within the manner
            determined by your explicit net browser. By disabling the cookie for
            your net browser, you can limit or restrict your personal
            information to the website. But it can hamper your services from the
            site if you do restrict.
          </TextBlock>
          <SubTitle>Acknowledgment to the Application (web & app) -</SubTitle>
          <TextBlock>
            The terms and conditions (T&Cs) as stipulated hereafter is an
            electronic record and shall represent lawfully enforceable agreement
            (Electronic Agreement) containing ‘Terms of Use’ of Maplun.com. Your
            use, access to Maplun.com within the application shall be deemed to
            be your acceptance of these T&Cs. You acknowledge and declare that
            you have read, scanned, understood, and agreed with these T&Cs.
          </TextBlock>
          <TextBlock>
            If you do not conform to these T&Cs, either whole or partly, and
            want to discontinue the Service, please don't continue or stop
            accessing to Maplun.com. You can share your thoughts at
            support@Maplun.com
          </TextBlock>
          <TextBlock>
            Please make sure that you read and understand the subsequent “Terms
            and Conditions” before you use Maplun.com Application (both web &
            app).
          </TextBlock>
        </MainContent>
      </Container>
      <Footer />
    </ContainerMain>
  );
}

export default DataSecuirity;
